// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1LFQC","inner":"Form_inner__1jU-m","range":"Form_range__3NYez","name":"Form_name__33C0z","actions":"Form_actions__1zhqE"};